import * as React from "react";
import {
  Datagrid,
  Filter,
  List,
  Pagination,
  ReferenceField,
  SearchInput,
  TextField,
} from "react-admin";

const ListFilters = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

const EmployeeListPagination = (props) => {
  return (
    <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
  );
};

export const EmployeeList = ({ ...props }) => {
  return (
    <List
      {...props}
      filters={<ListFilters />}
      perPage={25}
      sort={{ field: "updated", order: "DESC" }}
      exporter={false}
      pagination={<EmployeeListPagination />}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="lastName" />
        <TextField source="email" />
        <ReferenceField source="projectId" reference="projects" link="show">
          <TextField source="name" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
};
